import React from 'react';
import classes from './CardContainer.css';
const cardContainer = (props) => (
<div className={classes.appCardContainer+' appPYx'}>{props.children}</div>
);

export default cardContainer;


// WEBPACK FOOTER //
// ./src/hoc/CardContainer/CardContainer.js